import { readReadyExternalIntegrationStatus } from '@hxr/config/external-integrations';
import type { ExternalIntegrationStatus } from '@hxr/config/external-integrations';

export interface ReadinessBody {
  readonly status?: unknown;
  readonly integrations?: unknown;
}

export function readPclabDistributionReadiness(
  body: ReadinessBody,
  responseOK: boolean,
): ExternalIntegrationStatus | undefined {
  return readReadyExternalIntegrationStatus(
    body.integrations,
    'pclab-distribution',
    responseOK && body.status === 'ready',
  );
}
